export enum DL_PID_Type {
  search = 'search',
  category = 'category',
}
